// Define un tipo genérico para el entorno

import { Injector } from "@angular/core";
import { ENV } from "../interfaces/interfaces";
import { EncryptionService } from "../services/encryption.service";

export function getEnvironment(): ENV {
  // Validamos que window.selfEnv esté disponible
  if (!window.selfEnv) {
    // console.error('❌ getEnvironment(): window.selfEnv no está disponible');
    throw new Error('window.selfEnv no está disponible. Asegúrate de que early-init.ts se haya ejecutado correctamente.');
  }

  try {
    let _x = '12345678901234567890123456789012', _y = '1234567890123456';
    const injector = Injector.create({providers: [{provide: EncryptionService, useClass: EncryptionService, deps: []}]});
    const encryptionService = injector.get(EncryptionService);

    const encryptedEnv: ENV = encryptionService.decrypt(window.selfEnv, _x, _y);

    if (!encryptedEnv) {
      throw new Error('No se pudo desencriptar window.selfEnv');
    }

    // console.log('✅ getEnvironment(): Entorno desencriptado correctamente');
    return encryptedEnv;
  } catch (error) {
    // console.error('❌ getEnvironment(): Error al desencriptar:', error);
    throw new Error(`Error al desencriptar environment: ${error instanceof Error ? error.message : 'Error desconocido'}`);
  }
}
